<template>
  <div class="authorize-field">
    <el-row
      type="flex"
      :gutter="20">
      <el-col :span="8">
        <div class="authorize-field__title">
          {{text}}<b v-if="isRequired">*</b>:
        </div>
      </el-col>
      <el-col :span="16">
        <div class="authorize-field__switch-value">
          <div class="authorize-field__switch-text">
            Email
          </div>
          <el-switch
            :value="field.value"
            active-color="#02B771"
            @change="onChangeValue"/>
          <div class="authorize-field__switch-text">
            Телефон
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import input from '../mixins/input'

  export default {
    name: 'TypeAuth',
    mixins: [input],
    methods: {
      onChangeValue: function (e) {
        this.onChange(e)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Auth/Inputs/TypeAuth.vue